import Vue from 'vue'
import Router from 'vue-router'

import AccessDenied from './views/AccessDenied.vue'
import PageNotFound from './views/PageNotFound.vue'
import OAuthSuccess from './views/OAuthSuccess.vue'
import HostAccess from './views/HostAccess.vue'

import AppSettings from './components/appSettings/AppSettings.vue'

import Login from './components/users/Login.vue'
import Logout from './components/users/Logout.vue'
import UserForm from './components/users/UserForm.vue'
import UserBase from './components/users/UserBase.vue'
import UserList from './components/users/UserList.vue'

import AccountBase from './components/account/AccountBase.vue'
import AccountForm from './components/account/AccountForm.vue'
import SelectAccount from './components/account/SelectAccount.vue'

import WebcastDetailBase from './components/webcast/WebcastDetailBase.vue'
import WebcastList from './components/webcast/WebcastList.vue'
import WebcastSettings from './components/webcast/WebcastSettings.vue'
import StreamSettings from './components/webcast/StreamSettings.vue'
import RegistrationFormManagement from './components/webcast/RegistrationFormManagement.vue'
import ControlRoom from './components/webcast/ControlRoom.vue'
import PageSettings from './components/webcast/PageSettings.vue'
import PageSecurity from './components/webcast/PageSecurity.vue'
import LandingPage from './components/webcast/LandingPage.vue'
import Widgets from './components/webcast/Widgets.vue'
import EmbedAndLinks from './components/webcast/EmbedAndLinks.vue'
import Emails from './components/webcast/Emails.vue'

import QnaManager from './components/webcast/QnaManager.vue'

import Dashboard from './components/reports/Dashboard.vue'
import Attendees from './components/reports/Attendees.vue'
import EventSummary from './components/reports/EventSummary.vue'
import Registrations from './components/reports/Registrations.vue'
import WhoIsWatching from './components/reports/WhoIsWatching.vue'
import AudioParticipantsReport from './components/reports/AudioParticipantsReport.vue'


import Publisher from './components/webcast/selfService/Publisher.vue'
import AudioRoom from './components/webcast/selfService/AudioRoom.vue'


import store from './store'


Vue.use(Router);


let initApp = (to, from, next) => {
  store.dispatch('appsettings/getAppSettings').then((settings) => {
    store.commit('appsettings/setCurrent', settings);

    if (!settings) { $router.replace('/app-settings') }
    else if (settings.isFirstInit) { $router.replace('new-user') }
    else {
      store.dispatch('auth/authenticate').then((response) => {
        if (!store.state.auth.user) {
          console.log("can't find auth user");
          $router.replace('login')
        }

        if (window.$cookies.isKey('currentAccount')) {
          store.dispatch('account/setCurrent', window.$cookies.get('currentAccount')).then((response) => {
            next();
          })
        } else {
          if (to != 'selectAccount') {
            $router.replace('/account/select')
          } else {
            next();
          }
        }
      }).catch((err) => {
        console.log("auth error");
        console.log(err);
        $router.replace('login');
      });
    }
  })
}

let checkLogin = (to, from, next) => {
  if (!store.state.auth.user) {
    $router.replace('login')
  } else {
    next();
  }
}

var $router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound,
    },
    {
      path: '/403',
      name: 'access-denied',
      component: AccessDenied,
    },
    {
      path: '/hostLogin/:id',
      name: 'host-access',
      component: HostAccess,
    },
    {
      path: '/',
      name: 'webcastList',
      component: WebcastList,
      beforeEnter: initApp
    },
    {
      path: '/wc/:id',
      name: 'wc',
      component: WebcastDetailBase,
      beforeEnter: initApp,
      children: [
        {
          path: 'settings',
          name: 'wcSettings',
          component: WebcastSettings,
        },
        {
          path: 'streams',
          name: 'wcStreams',
          component: StreamSettings,
        },
        {
          path: 'control_room',
          name: 'controlRoom',
          component: ControlRoom,
        },
        {
          path: 'qna',
          name: 'qna',
          component: QnaManager,
        },
        {
          path: 'registration-form-management',
          name: 'registrationFormManagement',
          component: RegistrationFormManagement,
        },
        {
          path: 'report_dashboard',
          name: 'reportDashboard',
          component: Dashboard,
        },
        {
          path: 'attendee_report',
          name: 'attendeeReport',
          component: Attendees,
        },
        {
          path: 'who_is_watching',
          name: 'whoIsWatching',
          component: WhoIsWatching,
        },
        {
          path: 'summary_report',
          name: 'summaryReport',
          component: EventSummary,
        },
        {
          path: 'registrations_report',
          name: 'registrationsReport',
          component: Registrations,
        },
        {
          path: 'audio_participants',
          name: 'audioParticipnatsReport',
          component: AudioParticipantsReport,
        },
        {
          path: 'page-settings',
          name: 'pageSettings',
          component: PageSettings,
        },
        {
          path: 'page-security',
          name: 'pageSecurity',
          component: PageSecurity,
        },
        {
          path: 'landing-page',
          name: 'landingPage',
          component: LandingPage,
        },
        {
          path: 'widgets',
          name: 'widgets',
          component: Widgets,
        },
        {
          path: 'embed-and-links',
          name: 'EmbedAndLinks',
          component: EmbedAndLinks,
        },
        {
          path: 'emails',
          name: 'Emails',
          component: Emails,
        },
        {
          path: 'audio-room',
          name: 'AudioRoom',
          component: AudioRoom,
        }
      ]
    },
    {
      path: '/audioRoom/:id',
      name: 'audioRoom',
      component: AudioRoom,
      beforeEnter: initApp
    },
    {
      path: '/new-webcast',
      name: 'newWebcast',
      component: WebcastSettings,
      beforeEnter: initApp
    },
    {
      path: '/app-settings',
      name: 'appSettings',
      component: AppSettings,
      beforeEnter: initApp
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/user',
      name: 'user',
      component: UserBase,
      beforeEnter: initApp,
      children: [
        {
          path: 'new',
          name: 'newUser',
          component: UserForm
        },
        {
          path: 'list',
          name: 'userList',
          component: UserList
        },
        {
          path: 'oauth-success',
          name: 'OAuthSuccess',
          component: OAuthSuccess
        },
        {
          path: ':id',
          name: 'editUser',
          component: UserForm
        },

      ]
    },
    {
      path: '/account',
      name: 'account',
      component: AccountBase,
      beforeEnter: checkLogin,
      children: [
        {
          path: 'new',
          name: 'newAccount',
          component: AccountForm
        },
        {
          path: 'select',
          name: 'selectAccount',
          component: SelectAccount
        },
        {
          path: ':id',
          name: 'editAccount',
          component: AccountForm
        }
      ]
    },
    {
      path: '/publisher/:id',
      name: 'publisher',
      component: Publisher,
      beforeEnter: initApp
    },
  ]
})

export default $router
